import React from 'react';
import { Link } from 'react-router-dom';
import Wordmark from '../components/Wordmark';

export default function NotFoundPage() {
  return (
    <div style={sty.page}>
      <div style={sty.card}>
        <div style={sty.logo}><Wordmark /></div>
        <div style={sty.code}>404</div>
        <h1 style={sty.heading}>Page not found</h1>
        <p style={sty.body}>
          That URL doesn't exist. You may have followed an old link or mistyped the address.
        </p>
        <div style={sty.actions}>
          <Link to="/" style={sty.primary}>Go to Home →</Link>
          <Link to="/login" style={sty.secondary}>Sign In</Link>
          <Link to="/demo" style={sty.secondary}>Try Demo</Link>
        </div>
      </div>
    </div>
  );
}

const sty = {
  page: {
    minHeight: '100vh', backgroundColor: '#f5f3ef',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '24px', fontFamily: 'system-ui, sans-serif',
  },
  card: {
    backgroundColor: '#fff', border: '1px solid #e5e0d5', borderRadius: '16px',
    padding: '48px 40px', maxWidth: '400px', width: '100%', textAlign: 'center',
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  },
  logo: { marginBottom: '28px' },
  code: {
    fontSize: '72px', fontWeight: '800', color: '#e5e0d5',
    lineHeight: 1, marginBottom: '12px', letterSpacing: '-2px',
  },
  heading: { fontSize: '22px', fontWeight: '700', color: '#1a1a2e', margin: '0 0 10px' },
  body: { fontSize: '15px', color: '#6b6b7a', lineHeight: '1.6', margin: '0 0 28px' },
  actions: { display: 'flex', flexDirection: 'column', gap: '10px' },
  primary: {
    display: 'block', padding: '12px 20px',
    backgroundColor: '#1a1a2e', color: '#fff',
    borderRadius: '9px', fontWeight: '700', fontSize: '15px', textDecoration: 'none',
  },
  secondary: {
    display: 'block', padding: '11px 20px',
    backgroundColor: 'transparent', color: '#6b6b7a',
    border: '1px solid #e5e0d5', borderRadius: '9px',
    fontWeight: '500', fontSize: '14px', textDecoration: 'none',
  },
};
